module.exports = __webpack_public_path__ + "static/media/gallery.8a37c55f.svg";